import { type SourceAnalysisOrganizerFormData } from "@/types/models/Exportables.interface";

export const createRowsData = (): Array<{
  field: keyof SourceAnalysisOrganizerFormData;
  isRequired: boolean;
  text: string;
}> => [
  {
    field: "author",
    isRequired: true,
    text: "Who wrote or created the document?",
  },
  {
    field: "intended_audience",
    isRequired: false,
    text: "Who is the intended audience?",
  },
  {
    field: "year",
    isRequired: true,
    text: "What year was it written?",
  },
  {
    field: "world_events",
    isRequired: false,
    text: "What else was happening in the world at this time?",
  },
  {
    field: "evidence_of_bias",
    isRequired: false,
    text: "What evidence of bias do you see in the document?",
  },
  {
    field: "excluded_topics",
    isRequired: false,
    text: "What did the author omit or avoid talking about?",
  },
  {
    field: "reliability",
    isRequired: false,
    text: "Do you think this document is reliable? Why or why not?",
  },
  {
    field: "conclusion",
    isRequired: false,
    text: "Conclusion: How does this primary source contribute to our understanding of history?",
  },
];
